import { Container, Row, Col, Card } from "react-bootstrap";
import BillingHeader from "../../components/billingPayment/BillingHeader";
import BillingStats from "../../components/billingPayment/BillingStats";
import BillingOverviewChart from "../../components/billingPayment/BillingOverviewChart";
import RecentInvoices from "../../components/billingPayment/RecentInvoices";
import ChargesChart from "../../components/billingPayment/ChargesChart";
import PaymentMethods from "../../components/billingPayment/PaymentMethods";
import AutoPayCard from "../../components/billingPayment/AutoPayCard";
import TransactionsTable from "../../components/billingPayment/TransactionsTable";
import { useCallback, useEffect, useState } from "react";
import { Loader } from "../../components/common/Loader";
import { errorAlert } from "../../components/common/Alert";
import { getBillingAnalyticsApi, getBillingTransactionsApi, getBillingInvoicesApi, getBillingOverviewApi, getBillingCategoryAnalyticsApi } from "../../services/Networkcall";
import moment from "moment";

export default function BillingPage() {
  const [loading, setLoading] = useState(false);
  const [analyticsData, setAnalyticsData] = useState();
  const [transactionData, setTransactionData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [billingOverviewData, setBillingOverviewData] = useState();
  const [billingChargesData, setBillingChargesData] = useState();
  const [pagination, setPagination] = useState({ page: 1, limit: 5, totalRecords: 0, totalPages: 0 });
  const [invoicePagination, setInvoicePagination] = useState({ page: 1, limit: 10, totalRecords: 0, totalPages: 0 });
  const [billingMonth, setBillingMonth] = useState({ month: moment().format("MM"), year: moment().format("YYYY") });

  const fetchAnalyticsData = async () => {
    setLoading(true);
    try {
      const res = await getBillingAnalyticsApi();
      if (res?.success) {
        setAnalyticsData(res?.data || {});
      } else {
        errorAlert({ message: res?.message || "Failed to fetch billing report" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch billing report" });
    }
    setLoading(false);
  };

  const fetchTransactionsData = async () => {
    setLoading(true);
    try {
      const res = await getBillingTransactionsApi({ page: pagination.page, limit: pagination.limit });
      if (res?.success) {
        setTransactionData(res?.data || []);
        setPagination(prev => ({ ...prev, totalRecords: res?.totalRecords, totalPages: res?.totalPages }));
      } else {
        errorAlert({ message: res?.message || "Failed to fetch transactions report" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch transactions report" });
    }
    setLoading(false);
  };

  const fetchInvoicesData = async () => {
    setLoading(true);
    try {
      const res = await getBillingInvoicesApi({ page: invoicePagination.page, limit: invoicePagination.limit });
      if (res?.success) {
        setInvoiceData(res?.data || []);
        setInvoicePagination(prev => ({ ...prev, totalRecords: res?.totalRecords, totalPages: res?.totalPages }));
      } else {
        errorAlert({ message: res?.message || "Failed to fetch invoices report" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch invoices report" });
    }
    setLoading(false);
  };

  const fetchBillingOverviewChartData = async () => {
    setLoading(true);
    const payload = {
      month: billingMonth.month || moment().format("MM"),
      year: billingMonth.year || moment().format("YYYY"),
    }
    try {
      const res = await getBillingOverviewApi(payload);
      if (res?.success) {
        setBillingOverviewData(res?.data || []);
      } else {
        errorAlert({ message: res?.message || "Failed to fetch invoices report" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch invoices report" });
    }
    setLoading(false);
  };

  const fetchBillingChargeshartData = async () => {
    setLoading(true);

    try {
      const res = await getBillingCategoryAnalyticsApi();
      if (res?.success) {
        setBillingChargesData(res?.data || []);
      } else {
        errorAlert({ message: res?.message || "Failed to fetch invoices report" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch invoices report" });
    }
    setLoading(false);
  };


  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  useEffect(() => {
    fetchTransactionsData();
  }, [pagination?.page]);

  useEffect(() => {
    fetchInvoicesData();
  }, [invoicePagination?.page]);

  useEffect(() => {
    fetchBillingOverviewChartData();
  }, [billingMonth]);

  useEffect(() => {
    fetchBillingChargeshartData();
  }, []);

  const pageHandler = useCallback((page) => {
    setPagination(prev => ({ ...prev, page }));
  }, []);

  const invoicePageHandler = useCallback((page) => {
    setInvoicePagination(prev => ({ ...prev, page }));
  }, []);

  return (
    <Container fluid className="billing-page vh-100 overflow-scroll">
      <Loader show={loading} />

      <BillingHeader />

      <BillingStats analytics={analyticsData} />

      <Row className="mt-3 g-2">
        <Col xl={7} lg={12}>
          <BillingOverviewChart billingOverview={billingOverviewData} billingMonth={billingMonth} setBillingMonth={setBillingMonth} />
        </Col>

        <Col xl={5} lg={12}>
          <RecentInvoices invoices={invoiceData} invoicePagination={invoicePagination} invoicePageHandler={invoicePageHandler} />
        </Col>
      </Row>

      <Row className="mt-3 g-2">
        <Col xl={6} lg={12}>
          <ChargesChart chargesData={billingChargesData} />
        </Col>

        {/* <Col xl={4} lg={6}>
          <PaymentMethods />
        </Col> */}

        {/* <Col xl={3} lg={6}>
          <AutoPayCard />
        </Col> */}
      </Row>
      <Row className="mt-3">
        <Col>
          <Card className="rt-card"> 
            <div className="rt-header">
              <h6>Recent Transactions</h6>
            </div>
            <TransactionsTable transactions={transactionData} pagination={pagination} pageHandler={pageHandler} />
          </Card>
        </Col>
      </Row>

    </Container>
  );
}